import { SxProps, Theme } from '@mui/material';

export const inputStyles = {
  '& .MuiInputLabel-root': {
    color: '#666666',
    fontSize: '15px'
  },
  '& .MuiOutlinedInput-root': {
    height: '48px',
    borderRadius: '8px'
  }
};

export const disabledInputStyles = {
  ...inputStyles,
  '& .MuiOutlinedInput-root': {
    ...inputStyles['& .MuiOutlinedInput-root'],
    bgcolor: '#f5f5f5'
  }
};

export const sectionTitleStyles = {
  fontSize: '15px',
  fontWeight: 600,
  color: '#333333',
  mb: 2
};

export const sectionDescriptionStyles = {
  color: '#666666',
  fontSize: '13px',
  mb: 2
};

export const buttonStyles = (color: string): SxProps<Theme> => ({
  height: '48px',
  fontSize: '15px',
  fontWeight: 500,
  '&.MuiButton-contained': {
    bgcolor: color,
    color: '#ffffff',
    '&:hover': {
      bgcolor: color,
      opacity: 0.8
    }
  },
  '&.MuiButton-outlined': {
    color: color,
    borderColor: color,
    '&:hover': {
      borderColor: color,
      bgcolor: `${color}0a`
    }
  }
});

export const stackSpacing = 2;
export const sectionSpacing = 4; 